import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Col, Row, FormFeedback, InputGroupText } from 'reactstrap';
import "./PowerSaver.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useUnifiedMutate } from '../../../../../hooks/useUnifiedMutate';

function getDeviceType(boxDetails) {
  if (boxDetails?.Obis?.length) {
    for (let obi of boxDetails?.Obis) {
      if (obi?.macAddress?.startsWith("0026")) {
        return (
          <span>Setting a hibernation schedule will cause the device to go offline during scheduled off times. <br></br>
            This device can wake up from hibernation mode when any ATA port goes off-hook.
            <br></br>
            <strong>NOTE:</strong>It will take approximately 2-3 minutes for the unit to boot up and register before calls can be made.
          </span>
        )
      }
    }

    return (
      <span>Setting a hibernation schedule will cause the device to go offline during scheduled off times. <br></br>
        This device can only be woken up early from hibernation mode with a power cycle </span>
    )
  }
}

const PowerSaverSchedule = ({ isOpen, modalToggle, setPowerSchedule, powerSchedule, box }) => {
  const [inValue, setInValue] = useState('');
  const [offValue, setOffValue] = useState('');
  const [confirmModal, setConfirmModal] = useState(false);
  const [inValueError, setInValueError] = useState(false);
  const [offValueError, setOffValueError] = useState(false);

  const { mutate: requestPowerSaver, isLoading: isLoading } = useUnifiedMutate();

  const makePowerSaverRequest = async (action, payload={}) => {
    if(isLoading){
      return;
    }

    const endpoint = `boxes/power-saver/${box?._id}?action=${action}`;
    const method = 'POST';

    await requestPowerSaver({
      isMyEpik: false,
      endpoint,
      method,
      body: payload,
    });
  }

  useEffect(() => {
    makePowerSaverRequest('STATUS', {});
  }, [powerSchedule])

  const toggle = () => modalToggle(!isOpen);
  const toggleConfirm = () => setConfirmModal(!confirmModal);

  const handleSave = () => {
    if (!inValue) {
      setInValueError(true);
      return;
    }

    if (!offValue) {
      setOffValueError(true);
      return;
    }

    toggleConfirm();
  };

  const handleConfirm = async(choice) => {
    if (choice === 'yes') {
      setPowerSchedule({on: inValue, off: offValue});
      await makePowerSaverRequest('SET', [
        {"Number":1, "Process":"Normal", "Duration":`${inValue} hr`},
        {"Number":2, "Process":"Hibernation", "Duration":`${offValue} hr`},
      ])
    }
    toggleConfirm();
    toggle();
  };

  return (
    <div className="modal-component">
      {/* Main Modal */}
      <Modal isOpen={isOpen} toggle={toggle} centered className="wider-modal">
        <ModalHeader toggle={toggle}>Set Power Save Schedule</ModalHeader>
        <ModalBody>
          <Form>
            {/* Power On Interval */}
            <FormGroup>
              <Row className="align-items-center mb-3">
                <Col sm="4">
                  <Label for="inField" className="col-form-label">
                    Power On Interval
                  </Label>
                </Col>
                <Col sm="8">
                <div className="d-flex align-items-center">
                  <Input
                    type="number"
                    name="in"
                    id="inField"
                    min="1"
                    max="24"
                    value={inValue}
                    onChange={(e) => setInValue(e.target.value)}
                    invalid={inValueError}
                  />
                   <span className='pl-2'>Hours</span>
                   </div>
                  {inValueError && <FormFeedback>Missing value</FormFeedback>}
                </Col>
              </Row>
            </FormGroup>

            {/* Power Off Interval */}
            <FormGroup>
              <Row className="align-items-center mb-3">
                <Col sm="4">
                  <Label for="offField" className="col-form-label">
                    Power Off Interval
                  </Label>
                </Col>
                <Col sm="8">
                <div className="d-flex align-items-center">
                  <Input
                    type="number"
                    name="off"
                    id="offField"
                    min="1"
                    max="24"
                    value={offValue}
                    onChange={(e) => setOffValue(e.target.value)}
                    invalid={offValueError}
                  />
                   <span className='pl-2'>Hours</span>
                   </div>
                  {offValueError && <FormFeedback>Missing value</FormFeedback>}
                </Col>
              </Row>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={confirmModal} toggle={toggleConfirm} centered className="wider-modal">
        <ModalHeader toggle={toggleConfirm}>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{ color: '#eed202', stroke: 'black', strokeWidth: '1px' }}
          />
          <span className="pl-2">Confirm</span>
        </ModalHeader>
        <ModalBody>
          <p>{getDeviceType(box)}</p>
          <p className="confirm-values">Are you sure you want to proceed?</p>
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button color="secondary" onClick={() => handleConfirm('no')}>
            No
          </Button>
          <Button color="primary" onClick={() => handleConfirm('yes')}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PowerSaverSchedule;
